import Typography from './Typography'

export { TypographyTag, TypographyVariant } from './Typography.types'
export type { TypographyProps, Weight } from './Typography.types'

export default Typography
